if (!customElements.get('incontact-modal')) {
  customElements.define('incontact-modal', class InContactModal extends DetailsModal {
    constructor() {
      super();
      this.closeBtn = this.querySelectorAll('.js-close-modal');
    }
  
    /**
     * Handles 'click' events on the modal.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      var $this = this;
      if (this.hasTransition === undefined) {
        const overlayStyles = window.getComputedStyle(this.modal);
        this.hasTransition = overlayStyles.transition !== 'all 0s ease 0s';
      }
  
      if (!this.detailsEl.open) {
        if (evt.target === this.toggle) {
          evt.preventDefault();
          this.open();
        }
      } else if (evt.target === this.modal || evt.target === this.toggle) {
        evt.preventDefault();
        this.close();
      }

      this.closeBtn.forEach($el => {
        $el.addEventListener('click', () => {
          evt.preventDefault();
          $this.close();
        });
      });
    }
  });
}

var DateSelector = {
  locale: 'en-US',
  timezone: 'America/New_York',
  holidays: ["January 11"],
  daysOut: 2,
  days: [],
  start_time: "10:00",
  end_time: "16:30",
  displayDateOptions: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  displayTimeOptions: {
    hour: "2-digit",
    minute: "2-digit"
  },
  getESTDate(date) {
    var d = date || new Date();
    return new Date(Date.parse(d.toLocaleString("en-US", {timeZone: 'America/New_York'})));
  },
  today() { return this.getESTDate() },
  tomorrow() { return this.getESTDate() },
  rightnow: 0,
  thirtyMinutes: (30 * 60 * 1000),

  getTimeFromString(time) {
    return time.split(':');
  },

  getFormattedHolidays() {
    if (!this.holidays.length) {
      return [];
    }

    const dates = [];
    this.holidays.forEach((holiday) => {
      var date = new Date(holiday);
      date.setYear(new Date().getFullYear())
      dates.push(date.toLocaleDateString("en-US"));
    })
    return dates;
  },

  getDateTime(date, hour, minute) {
    const time = this.getESTDate(date);
    time.setHours(hour)
    time.setMinutes(minute);
    time.setSeconds(0);
    return time;
  },

  getLocaleFormatDate(date) {
    return date.toLocaleString(this.locale, this.displayDateOptions);
  },

  getLocaleFormatTime(time) {
    return time.toLocaleTimeString([], this.displayTimeOptions);
  },

  isValidDate(date) {
    const isAHoliday = this.getFormattedHolidays().includes(date.toLocaleDateString(this.locale));
    const isAWeekend = ((date.getDay() === 6) || (date.getDay() === 0));
    return !(isAHoliday || isAWeekend);
  },

  formatDays() {
    let i = 0;
    while (this.days.length < this.daysOut) {
      const nextDay = new Date();
      const endTime = this.getTimeFromString(this.end_time); 
      
      if (this.getDateTime(this.getESTDate(), endTime[0], endTime[1]) < this.today) {
        nextDay.setDate(this.tomorrow().getDate() + i); 
      } else {
        nextDay.setDate(this.today().getDate() + i); 
      }
      if (this.isValidDate(nextDay)) {
        this.days.push(nextDay)
      }
      i++;
    }
  },
  
  // Pad a number to 2 digits
  pad(n) {
    return `${Math.floor(Math.abs(n))}`.padStart(2, '0');
  },
  
  getTimezoneOffset(date) {
    const tzOffset = -date.getTimezoneOffset();
    const diff = tzOffset >= 0 ? '+' : '-';
    return diff + this.pad(tzOffset / 60) + ':' + this.pad(tzOffset % 60);
  },

  getASAP() {
    const fiveFromNow = moment().add(5, 'm');
    return {
      value: fiveFromNow.tz('America/New_York').format(),
      display: fiveFromNow.format('LT') + " ET"
    };
  },

  getSlot(time) {
    const thirtyFromNow = moment(time.toLocaleString()).add(30, 'm');
    var m = moment(time.toLocaleString());
    return {
      value: m.format(),
      display: m.format('LT') + ' to ' + thirtyFromNow.format('LT') + " ET"
    };  
  },

  getTimeSlots(options) {
    const $this = this;
    if (typeof options === 'Object' && Object.keys(options).length) {
      $this.syncOptions(options);  
    }
    $this.formatDays();
    const timeSlots = {};
    const dailyStartTime = this.getTimeFromString($this.start_time);
    const dailyEndTime = this.getTimeFromString($this.end_time);
    this.days.forEach((day) => {
      const nextTime = $this.getDateTime(day, dailyStartTime[0], dailyStartTime[1]);
      const lastTime = $this.getDateTime(day, dailyEndTime[0], dailyEndTime[1]);
      timeSlots[$this.getLocaleFormatDate(day)] = timeSlots[$this.getLocaleFormatDate(day)] || [];
      
      while(nextTime < lastTime) {
        if (nextTime > this.getESTDate()) {
          timeSlots[$this.getLocaleFormatDate(day)].push($this.getSlot(nextTime));
        }
        nextTime.setTime(nextTime.getTime() + this.thirtyMinutes);
      }
    });
    return timeSlots;
  },

  syncOptions(options) {
    let $this = this;
    Object.keys(options).forEach((key) => {
      $this[key] = options[key];
    });
    return $this;
  }
};

const callBackTime = document.getElementById('callback_time');
const selector = DateSelector.syncOptions({
  start_time: callBackTime.dataset.start_time,
  end_time: callBackTime.dataset.end_time,
  holidays: callBackTime.dataset.holidays.split('|')
});
timeSlots = selector.getTimeSlots();
Object.keys(timeSlots).forEach((day) => {
  let optGroup = document.createElement('optgroup');
  optGroup.setAttribute("label", day);
  
  timeSlots[day].forEach((time) => {
    let option  = document.createElement('option');
    option.setAttribute("value", time.value);
    option.innerHTML = time.display;
    optGroup.appendChild(option);
  });
  callBackTime.appendChild(optGroup);
});

const $modal = document.querySelector('.incontact-modal-container');
if ($modal) {
  const $fields = $modal.querySelectorAll("input, select");
  const submitButtons = $modal.querySelectorAll('.incontact-page-submit');  

  const generateErrorMessage = (field, message) => {
    if (message) {
      field.setCustomValidity(message);
    }
    field.checkValidity();
  };

  const serverError = (message) => {
    const $form = document.getElementById("incontact-form");
    const $error = document.createElement("div");
    $error.classList.add('error-message');
    $error.innerHTML = message;
    $form.prepend($error);
  };

  const clearErrors = () => {
    const $errors = document.querySelectorAll('.error-message');
    $errors.forEach(error => {
      error.parentNode.removeChild(error);
    });
  };

  const showPage = (pageNo) => {
    const $pages = document.querySelectorAll('.incontact-form-section');
    $pages.forEach(page => {
      if (page.dataset.page === pageNo.toString()) {
        page.style.display = 'block';
      } else {
        page.style.display = 'none';  
      }
    });
  };

  const callbackValues = { 'asap': false };

  const updateCallBackUI = (nextPage) => {
    document.querySelectorAll('.callback-topic-results').forEach( (el) => {
      el.innerHTML = callbackValues['topic'];
    });
    document.querySelectorAll('.callback-datetime-results').forEach( (el) => {
      el.innerHTML = callbackValues['callback_time'];
    });
    showPage(nextPage);
  }

  const updateCallback = (response, nextPage) => {
    if (response.error === true) {
      serverError(response.message);
    } else if (response.status === 200) {
      if (response.object && response.object.callbackId) {
        callbackValues['callback_id'] = response.object.callbackId;
      }
      updateCallBackUI(nextPage);
    } else {
      serverError('Your request could not be completed. Please try again later.')
    }
  }

const sendData = async (formData, endpoint, nextPage) => {
  const $form = document.getElementById('incontact-form');
  let action = '';
  if ($form) {
    action = $form.getAttribute('action');
  }

    const response = await fetch(action + endpoint, {
      method: "POST",
      // Set the FormData instance as the request body
      body: formData,
    });
    updateCallback(await response.json(), nextPage);
  };

  const submitSchedule = (formData) => {
    const scheduleCallback = 'api/schedule/create';
    sendData(formData, scheduleCallback, 3);
  };

  const submitCancel = (formData) => {
    const cancelCallback = 'api/schedule/cancel';
    sendData(formData, cancelCallback, 5);
  };
    
  submitButtons.forEach(el => el.addEventListener('click', event => {
    const $el = event.target;
    const page = $el.dataset.page;
    let hasErrors = false;
    clearErrors();
    let $topicSelection;
    let $firstName;
    let $phone;
    let $callbackTime;
    let formData = new FormData();
    switch (page) {
      case '1':
        $topicSelection = document.getElementById("topic");
        if ($topicSelection.value === '') {
          $topicSelection.classList.add("invalid");
          generateErrorMessage($topicSelection, $topicSelection.dataset.error);
          hasErrors = true;
        }
        if (!hasErrors) {
          callbackValues['topic'] = $topicSelection.options[$topicSelection.selectedIndex].text;
          showPage(2);
        }
        break;
      case '2':
        $topicSelection = document.getElementById("topic");
        $firstName = document.getElementById("first_name");
        $lastName = document.getElementById("last_name");
        $phone = document.getElementById("phone_number");
        $callbackTime = document.getElementById("callback_time");
        if ($firstName.value === '') {
          $firstName.classList.add("invalid");
          generateErrorMessage($firstName, $firstName.dataset.error);
          hasErrors = true;
        }
        if ($lastName.value === '') {
          $lastName.classList.add("invalid");
          generateErrorMessage($lastName, $lastName.dataset.error);
          hasErrors = true;
        }
        if ($phone.value.length !== 10) {
          $phone.classList.add("invalid");
          generateErrorMessage($phone, $phone.dataset.error);
          hasErrors = true;
        }
        if ($callbackTime.value === '') {
          let callbackTime;
          $callbackTime.classList.add("invalid");
          generateErrorMessage($callbackTime, $callbackTime.dataset.error);
          hasErrors = true;
        } else {
          callbackTime = $callbackTime.value;
          callbackValues["callback_time"] = $callbackTime.options[$callbackTime.selectedIndex].text;
        }

        if (!hasErrors) {
          formData = new FormData();
          formData.append('phone', $phone.value);
          formData.append('topic', $topicSelection.value);
          formData.append('first_name', $firstName.value);
          formData.append('last_name', $lastName.value);
          formData.append('callback_time', callbackTime);
          submitSchedule(formData);
        }
        
        break
      case '3':
        showPage(4);
        break;
      case '4':
        formData = new FormData();
        formData.append('callback_id', callbackValues["callback_id"]);
        submitCancel(formData);
        break;
    };

  }));

  $fields.forEach((field) => {
    field.addEventListener("invalid", (event) => {
      event.preventDefault();
      event.target.setAttribute('aria-invalid', "true");
      event.target.parentNode.insertAdjacentHTML( "beforeend", "<div class='error-message'>" + field.validationMessage + "</div>" );
    }, true );
    field.addEventListener("change", (event) => {
      event.target.classList.remove('invalid');
      let $error;
      if($error = event.target.parentNode.querySelector('.error-message')) {
        event.target.parentNode.removeChild($error);  
      }
      event.target.setAttribute('aria-invalid', "false");
    }, true );
  });
}
    